import { useParams } from 'react-router-dom'

export function useDealerCode() {
  const { dealerCode } = useParams<{ dealerCode?: string }>()
  switch (dealerCode) {
    case undefined:
      return ''
    case 'ncbank':
      return dealerCode
    default:
      return undefined
  }
}

export function useDealerCodeUrl(path: string) {
  const { dealerCode } = useParams<{ dealerCode?: string }>()
  return dealerCode === '' || dealerCode === undefined ? path : `/${dealerCode}${path}`
}
